module.exports = __webpack_public_path__ + "img/top.a75e8d6c.png";